import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fc11034"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "about2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wenhao" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wenhaoTxt" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "txt1" }, "以下哪些药物适合该患者？")
  ])
], -1))
const _hoisted_4 = { class: "zljg" }
const _hoisted_5 = { class: "wenti" }
const _hoisted_6 = { class: "radioBox" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jimei" }, "JAK：Janus激酶", -1))
const _hoisted_13 = {
  key: 0,
  class: "swperList"
}
const _hoisted_14 = { class: "bottomBox" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ip" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, { show: true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_checkbox_group, {
                modelValue: $data.checkVal,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.checkVal) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_van_checkbox, {
                      key: "1",
                      value: "1",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "1"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_7)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("A.生物制剂 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_van_checkbox, {
                      key: "2",
                      value: "2",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "2"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_8)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("B.系统免疫制剂 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_van_checkbox, {
                      key: "3",
                      value: "3",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "3"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_9)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("C. JAK1抑制剂 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_van_checkbox, {
                      key: "4",
                      value: "4",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "4"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_10)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("D.短期系统糖皮质激素 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_van_checkbox, {
                      key: "5",
                      value: "5",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "5"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_11)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("E.渗出部位联用外用抗生素 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _hoisted_12
          ]),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_van_image, {
                  width: "5.2667rem",
                  height: "4.8rem",
                  src: require('../assets/gongge.jpg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_van_image, {
            onClick: $options.jieti,
            width: "4.528rem",
            height: "1.32rem",
            src: require('../assets/jiemi.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _hoisted_15,
    _hoisted_16,
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}